import { HttpClient } from '@angular/common/http';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import {Asset} from "@models/ai-reports/shared/assets";

export type AssetBlobMode = 'json' | 'text' | 'image';

@Pipe({
	name: 'assetBlob',
	pure: true,
	standalone: true,
})
export class AssetBlobPipe implements PipeTransform {
	private readonly http = inject(HttpClient);
	private readonly sanitizer = inject(DomSanitizer);

	transform(
		assetOrId: Asset | string | null | undefined,
		mode: 'json'
	): Observable<object>;

	transform(
		assetOrId: Asset | string | null | undefined,
		mode: 'text'
	): Observable<string>;

	transform(
		assetOrId: Asset | string | null | undefined,
		mode: AssetBlobMode = 'json'
	) {
		const id = typeof assetOrId === 'string' ? assetOrId : assetOrId?.id;
		if (!id) return undefined;

		const url = `${environment.apiBaseUrl}${environment.endpoint.assets.image}/${id}`;
		switch (mode) {
			case 'json':
				return this.http.get(url, {
					responseType: 'json',
				});
			case 'text':
				return this.http.get(url, {
					responseType: 'text',
				});
			case 'image':
				return this.http
					.get(url, {
						responseType: 'blob',
					})
					.pipe(
						map((blob) =>
							this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob))
						),
						tap((url) => console.log('Blob URL:', url)),
						catchError((err) => {
							console.error('Error loading blob:', err);
							return of(null);
						})
					);
			default:
				return this.http.get(url, {
					responseType: 'text',
				});
		}
	}
}
